import { useAuthStore } from '@/stores/authStore'
import { useActiveLessonRealtime } from '@/realtime/useActiveLessonRealtime'
import { useActiveLessonSync } from '@/realtime/useActiveLessonSync'

/**
 * Глобальный слой данных плашки текущего урока — только для авторизованного
 * пользователя: первый запрос и сброс (useActiveLessonSync), живое обновление
 * без перезагрузки (useActiveLessonRealtime). Сама плашка рисуется в каркасе
 * кабинета (ActiveLessonBar в DashboardLayout и ProfileLayout), а данные живут
 * здесь: переходы между страницами не перезапрашивают урок и не пересоздают подписки.
 */
export function ActiveLessonLayer() {
  const userId = useAuthStore((state) =>
    state.isAuthenticated ? (state.user?.id ?? null) : null,
  )

  useActiveLessonSync(userId)
  useActiveLessonRealtime(userId)

  return null
}
